module.exports = __webpack_public_path__ + "img/cover-clashofcats.58db2b10.png";